<template>
    <div class="footer">
            <div class="fttop">
                <div class="content">
                    <div class="logo">
                        <router-link to='/'><img class="shopimg" :src="shopIcon" alt=""></router-link>
                        <div class="icon">
                            <img src="@/assets/images/qq.png" alt="">
                            <img src="@/assets/images/wechat.png" alt="">
                            <img src="@/assets/images/phone.png" alt="">
                        </div>
                    </div>
                    <div class="contact">
                        <div class="con1">
                            <p @click="contactUs">联系我们</p>
                            <p><router-link to="/privacy">隐私协议</router-link> </p>
                        </div>
                        <p v-show="showPhone">服务热线：027-86512549</p>
                    </div>
                    <div class="about">
                        <p>服务时间：<span>早7:00~晚10:00</span></p>
                        <p>服务热线：027-86512549</p>
                        <p>总部地址：湖北省武汉市华中农大北</p>
                    </div>
                </div>
            </div>
            <div class="ftbt">
                <p>Copyright@2018-2019湖北水果商城电子商务有限公司<span>All rights Reserved</span></p>
                <p class="num">
                    <img src="@/assets/images/police.png" alt="">
                    鄂ICP备19003266号
                </p>
            </div>
        </div>
</template>

<script>
export default {
    name:'vfooter',
    data(){
        return{
            shopIcon:require('@/assets/images/logo.png'),
            showPhone:false,
        }
    },
    methods:{
        contactUs(){
            var that = this;
            that.showPhone = !that.showPhone
        }
    }
}
</script>


<style>
.footer{
    background-color: #333;
    color: #fff;
    text-align: center;
    font-size: 0.9vw;
}
.fttop{
    border-bottom: 1px solid #666;
}
.fttop .content{
    display: flex;
    justify-content: space-between;
    padding: 2% 15%;
}
.fttop .logo{
    padding: 0 0.2rem 0.2rem;
}
.logo .shopimg{
    width: 11vw;
}
.fttop .icon{
    margin-top: 20px;
    width: 11vw;
    display: flex;
    justify-content: space-between
}
.icon img{
    width: 20%;
    height: 30%;
}
.fttop .contact{
    align-self: flex-start;
    text-align: left;
    /* margin-top: 1vw; */
}
.contact .con1{
    display: flex;justify-content: space-between;
}
.contact a{
    color: #fff;
    text-decoration: none
}
.contact p:first-child{
    margin-right: 75px;
}
.fttop .about span{
    font-size: 1.5vw;
}
.about{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.about p:last-child{
    margin-bottom: 0;
}
.ftbt p{
    margin: 10px 0px 5px;
    font-size: 13px;
}
.ftbt .num{
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}
.num img{
    margin-right: 8px;
}
</style>




// WEBPACK FOOTER //
// src/components/footer.vue